import "../../styles/Register.css"

import Banner from "../navigation/Banner"
import NavBar from "../navigation/NavBar"
import SignUpForm from "./SignUpForm"
import LogInForm from "./LogInForm"
import Footer from "../navigation/Footer"

function Register({setUser}) {
  
  return (
    <div className="register-page-container" >
      <Banner />
      <NavBar />

      <div className="register-page-content-container">
        <div className="register-content-1">
          <SignUpForm setUser={setUser} />
          <LogInForm setUser={setUser} />

          <div className="slice-container">
            <span className="register-note">For delivery, order through SliceLife!</span>
            <button className="order-now-button slicelife-button" onClick={(e) => {
              e.preventDefault();
              localStorage.removeItem("token")
              window.open("https://slicelife.com/restaurants/ri/providence/02903/ristorante-roma/menu?utm_campaign=order_now_button&utm_medium=referral&utm_source=romapizzaprovidence.com", "_blank");
              }}
            >SliceLife!</button>
          </div>
        </div>

        <Footer />
        
      </div>
    </div>
  )
}

export default Register
